<template>
  <modal-card :ctrl="control">
    <div slot="body">
      <h4 class="title is-5">{{ ctrl.prompt || '请提供一个输入' }}</h4>
      <div class="field">
        <input v-model.trim="input" @keydown.enter="confirm(false)" class="input" type="text">
      </div>
      <div class="buttons">
        <button @click="confirm"
                class="button is-primary">确认
        </button>

        <button @click="stop"
                class="button is-outlined is-danger flex-pull-right">中止程序
        </button>
      </div>
    </div>
  </modal-card>
</template>
<script>
  import ModalCard from '@/common/layout/ModalCard.vue'
  import IClassroom from '@/components/classroom/lib/IClassroom'

  export default {
    props: {
      'ctrl': { type: Object }
    },
    data () {
      return {
        IClassroom,
        input: '',
        control: {
          active: false,
          force: false,
          noHeader: true,
          noFooter: true
        }
      }
    },
    watch: {
      'ctrl.active' (val) {
        this.control.active = val
        this.control.force = !!val
        this.input = ''
      }
    },
    methods: {
      confirm () {
        this.ctrl.active = false
        this.ctrl.resolve({ value: this.input, prompt: this.prompt })
      },
      stop () {
        this.ctrl.stop && this.ctrl.stop()
        this.ctrl.active = false
      }
    },
    components: { ModalCard }
  }
</script>
<style scoped>
  .problems {
    min-height: 70vh;
    margin: -30px -20px;
  }

  .dropdown-menu {
    min-width: 320px;
  }

  .input {
  }
</style>
